import React, { Component } from 'react';
import {Route} from "react-router-dom";
import {organisationDetails} from "../../util/ApiUtils";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import {withStyles} from "@material-ui/styles";
import {Spinner} from "../common/Spinner";
import ProjectManagementPage from "./ProjectManagementPage";
import { t } from '../../i18n';

const classes = () => ({
    card: {
        width: '100%',
    },
});

class ProjectManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latestRevision: {},
            isLoading: true,
        };
        this.loadOrganisationDetails = this.loadOrganisationDetails.bind(this);
    }

    componentDidMount() {
        this.loadOrganisationDetails();
    }

    loadOrganisationDetails() {
        organisationDetails()
            .then(response => {
                console.log(response);
                this.setState({
                    organisation: response,
                    orgId: response.id,
                    latestRevision: response.latestRevisionDto,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    render() {
        let { state } = this;
        const { classes } = this.props;

        if (state.isLoading) {
            return <Spinner/>;
        }

        return <div className="mui-container-fluid">
                <Card className={classes.card}>
                    <CardHeader
                        title={
                            <p style={{color: "darkblue"}}><b>{ t('menu.projectManagement.title') }</b></p>
                        }
                        subheader={
                            <span>
                            </span>
                        }
                    />
                    <CardContent>
                        <hr/>
                        <Route
                            path={`/project-management/project-management`}
                            render={() =>
                                <ProjectManagementPage currentUser={this.props.currentUser}/>
                            }
                        />
                    </CardContent>
                </Card>
            </div>;
    }
}

export default withStyles(classes)(ProjectManagement);